import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles(
	({ breakpoints, palette, spacing }: Theme) => ({
		toolbar: {
			backgroundColor: palette.primary.main,
			padding: 0
		},
		toolbarElement: {
			"&:first-child": {
				width: 300,
				[breakpoints.down("sm")]: {
					width: 64
				}
			},
			"&:last-child": {
				maxWidth: 300,
				display: "flex",
				justifyContent: "flex-end",
				paddingLeft: 40,
				paddingRight: 40,
				[breakpoints.down("sm")]: {
					width: 140
				},
				[breakpoints.down("xs")]: {
					width: 72,
					paddingRight: 0
				}
			},
			alignItems: "center",
			display: "flex",
			justifyContent: "center",
			height: 64,
			backgroundColor: "#798739"
		},
		userName: {
			fontStyle: "normal",
			fontWeight: "bold",
			fontSize: 14,
			textAlign: "right",
			color: "#FFFFFF",
			paddingRight: 12,
			textTransform: "none",
			[breakpoints.down("sm")]: {
				display: "none"
			},
			overflow: "hidden",
			textOverflow: "ellipsis"
		},
		siteName: {
			fontStyle: "normal",
			fontWeight: 900,
			fontSize: "22px",
			letterSpacing: "1px",
			color: "#FFFFFF",
			fontFamily: "Roboto",
			textTransform: "capitalize",
			[breakpoints.down("sm")]: {
				display: "none"
			}
		},
		deployVersion: {
			fontStyle: "normal",
			fontWeight: 900,
			fontSize: "22px",
			letterSpacing: "1px",
			color: "#FFFFFF",
			fontFamily: "Roboto",
			paddingLeft: 24
		},
		additionalData: {
			fontStyle: "normal",
			fontWeight: 900,
			fontSize: "17px",
			letterSpacing: "1px",
			color: "#FFFFFF",
			fontFamily: "Roboto",
			paddingLeft: 24,
			position: "relative"
		},
		hide: {
			display: "none"
		},
		menuButton: {
			[breakpoints.up("md")]: {
				display: "none"
			}
		},
		appInformations: {
			display: "block",
			paddingBottom: spacing(1),
			textSize: 12
		},
		appInfo: {
			fontWeight: "bold",
			paddingRight: spacing(1),
			marginRight: spacing(1),
			borderRight: "2px solid #798739"
		}
	}),
	{ name: "Toolbar" }
);
